import type { FC } from 'react';

import {
  CallDetailsParticipant,
  ChangePhoneNumberContainer,
} from 'features/call/call-details/components';
import type { CallDetailsParticipantInfo } from 'features/call/call-details/interfaces';
import { CustomGreeting } from 'features/custom-greeting/components';

export interface CallDetailsChangeNumberProps {
  caller: CallDetailsParticipantInfo;
}

export const CallDetailsChangeNumber: FC<CallDetailsChangeNumberProps> = ({
  caller,
}) => {
  return (
    <>
      <CustomGreeting />
      <CallDetailsParticipant {...caller} />
      <ChangePhoneNumberContainer />
    </>
  );
};
